import apiPlatform from "../../apiPlatform";

export const SET = 'JobCategories/SET';
export const ADD = 'JobCategories/ADD';
export const DELETE = 'JobCategories/DELETE';

export function setJobCategories(jobCategories) {
  return {
    type: SET,
    jobCategories
  }
}

export function jobCategoriesReload() {
  return dispatch => apiPlatform.jobCategory.list().then(res => {
    dispatch(setJobCategories(res.data['hydra:member']))

    return res
  })
}

export function jobCategoryCreate(data) {
  return dispatch => apiPlatform.jobCategory.create(data).then(res => {
    dispatch({
        type: ADD,
        jobCategory: res.data,
      }
    )

    return res
  })
}

export function jobCategoryDelete(id) {
  return dispatch => apiPlatform.jobCategory.delete(id).then(() => {
    dispatch({
        type: DELETE,
        id,
      }
    )

    return id
  })
}